import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SETTINGS, CPT_CODES } from "@/lib/soap";
import { TimePicker } from "@/components/TimePicker";

export function Card({ title, action, children, className = "" }) {
  return (
    <section className={`rounded-xl border bg-white p-5 sm:p-6 ${className}`}>
      <div className="flex items-center justify-between gap-3 mb-4">
        <h3 className="text-base font-semibold text-slate-900">{title}</h3>
        {action}
      </div>
      {children}
    </section>
  );
}

export function SessionInfoCard({ form, set, clients, onClientChange }) {
  return (
    <Card title="Session details">
      <div className="grid grid-cols-2 gap-4">
        <div className="col-span-2 space-y-1.5">
          <Label>Client</Label>
          <Select value={form.client_id || "none"} onValueChange={onClientChange}>
            <SelectTrigger className="h-10" data-testid="client-select-dropdown"><SelectValue placeholder="Select client" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">No client selected</SelectItem>
              {clients.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="col-span-2 space-y-1.5">
          <Label>Date</Label>
          <Input type="date" value={form.session_date} onChange={(e) => set("session_date", e.target.value)} data-testid="session-date-input" />
        </div>
        <div className="col-span-2 space-y-1.5">
          <Label>Start time</Label>
          <TimePicker value={form.start_time} onChange={(v) => set("start_time", v)} testId="session-start" />
        </div>
        <div className="col-span-2 space-y-1.5">
          <Label>End time</Label>
          <TimePicker value={form.end_time} onChange={(v) => set("end_time", v)} testId="session-end" />
        </div>
        <div className="space-y-1.5">
          <Label>Setting</Label>
          <Select value={form.setting} onValueChange={(v) => set("setting", v)}>
            <SelectTrigger data-testid="session-setting-select"><SelectValue /></SelectTrigger>
            <SelectContent>{SETTINGS.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label>CPT code</Label>
          <Select value={form.cpt_code} onValueChange={(v) => set("cpt_code", v)}>
            <SelectTrigger data-testid="session-cpt-select"><SelectValue /></SelectTrigger>
            <SelectContent>{CPT_CODES.map((c) => <SelectItem key={c.code} value={c.code}>{c.label}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </div>
    </Card>
  );
}
